// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603201433/js/" + chunkId + "." + {"44":"4186da28","225":"4f05a2aa","481":"93b35dbe","486":"00153725","770":"1103cc98"}[chunkId] + ".0.8991648442223874.chunk.js";
};